<template>


<md-list class="md-double-line" id="ql-sidenav-layer-list">
    <md-dialog-confirm
        :md-title="'Confirm Layer Delete'"
        :md-content-html="'This layer contains cues. Are you sure you want to delete it?'"
        :md-ok-text="'Yes'"
        :md-cancel-text="'Cancel'"
        @close="dialogClose"
        ref="deleteLayerDialog">
    </md-dialog-confirm>
    <layer v-for="layer in layers"
        :layer="layer"  
        :key="layer.id"
        :viewable="canView(layer)"
        :editable="canEdit(layer)"
        :showNotes="canShowNotes(layer)"
        :project="project"
        @updateLayer="updateLayer" 
        @deleteLayer="tryDeleteLayer"
        @showLayer="showLayer"
        @hideLayer="hideLayer"/>
</md-list>
</template>

<script>
// import firebase from 'firebase';
import { mapGetters } from 'vuex';
import LayersLayer from '@/components/layers/layer';

const LayersNav = {
    name: 'CoreHeader',
    props: ['project', 'layers'],
    data: function() {
        return {
            newLayerTitle: '',
            layerToDelete: null
        };
    },
    components: {
        layer: LayersLayer
    },
    computed: {
        ...mapGetters([
            'visibleLayerIDs',
            'showNotesLayers',
            'editableLayers',
            'cuesPerLayer'
        ])
    },
    methods: {
        canView(layer) {
            const layerIDs = this.visibleLayerIDs;
            return layerIDs.includes(layer.id);
        },
        canEdit(layer) {
            const layerIDs = this.editableLayers.map(l => l.id);
            return layerIDs.includes(layer.id);
        },
        canShowNotes(layer) {
            return this.showNotesLayers.includes(layer.id);
        },
        hideLayer(layer) {
            this.$store.dispatch('hideLayer', layer);
        },
        showLayer(layer) {
            this.$store.dispatch('showLayer', layer);
        },
        updateLayer(layer) {
            this.$store.dispatch('updateLayer', layer);
        },
        dialogClose(type) {
            if (type === 'cancel') {
                this.layerToDelete = null;
            } 
            if (type === 'ok') {
                this.deleteLayer();
            }
        },
        tryDeleteLayer(layer) {
            const numCues = this.cuesPerLayer(layer.id).length;
            this.layerToDelete = layer;
            if (numCues === 0) {
                this.deleteLayer();
            } else {
                this.$refs.deleteLayerDialog.open();
            }
        },
        deleteLayer() {
            if (this.layerToDelete) {
                this.$store.dispatch('removeLayer', this.layerToDelete);
                this.$store.dispatch('hideLayer', this.layerToDelete);
            }
        }
    }
};
export default LayersNav;

</script>

<style>
</style>


// WEBPACK FOOTER //
// layer-list.vue?9a2e2c1c